import __vue_component__$1 from './MdInkRipple.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

const MdButton = {
  name: "md-button",
  components: {
    MdInkRipple: __vue_component__$1
  },
  props: {
    mdWide: {
      type: Boolean,
      default: false
    },
    href: String,
    target: String,
    rel: String,
    type: {
      type: String,
      default: "button"
    },
    disabled: Boolean,
    badge: Number,
    borderStyle: {
      type: String,
      default: "thinner"
    },
    colorBorderStyle: {
      type: String,
      default: "black"
    },
    shadowStyle: {
      type: String,
      default: "dark"
    },
    minWidth: {
      type: String,
      default: "64px"
    },
    disableRipple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssVariables() {
      return {
        "--button-min-width": this.minWidth
      };
    },
    newRel() {
      if (this.target === "_blank") {
        return this.rel || "noopener";
      }
      return this.rel;
    },
    badgeText() {
      return this.badge <= 99 ? this.badge : "99+";
    },
    borderClass() {
      if (this.colorBorderStyle === "black") {
        if (this.borderStyle === "thicker") {
          return "md-raised--thicker-border";
        } else if (this.borderStyle === "none") {
          return "md-raised--no-shadow";
        } else {
          return "md-raised--thinner-border";
        }
      } else {
        if (this.borderStyle === "thicker") {
          return "md-raised--thicker-border-gray";
        } else if (this.borderStyle === "none") {
          return "md-raised--no-shadow";
        } else {
          return "md-raised--thinner-border-gray";
        }
      }
    },
    shadowClass() {
      if (this.borderStyle !== "none") {
        if (this.shadowStyle === "dark") {
          return "md-raised--dark-shadow";
        } else if (this.shadowStyle === "light") {
          return "md-raised--light-shadow";
        } else {
          return "md-raised--gray-dark-shadow";
        }
      }
    }
  }
};

const __vue_script__ = MdButton;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.href ? _c('a', {
    staticClass: "md-button",
    class: [_vm.borderClass, _vm.shadowClass],
    style: _vm.cssVariables,
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled,
      "target": _vm.target,
      "rel": _vm.newRel
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      },
      "mouseover": function ($event) {
        return _vm.$emit('mouseover', $event);
      }
    }
  }, [_vm.badge ? _c('div', {
    staticClass: "md-button__badge"
  }, [_vm._v(_vm._s(_vm.badgeText))]) : _vm._e(), _vm._v(" "), !_vm.disableRipple ? _c('md-ink-ripple', {
    attrs: {
      "md-disabled": _vm.disabled
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _c('button', {
    staticClass: "md-button",
    class: [_vm.borderClass, _vm.shadowClass, {
      'md-wide': _vm.mdWide
    }],
    style: _vm.cssVariables,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      },
      "mouseover": function ($event) {
        return _vm.$emit('mouseover', $event);
      }
    }
  }, [_vm.badge ? _c('div', {
    staticClass: "md-button__badge"
  }, [_vm._v("\n    " + _vm._s(_vm.badgeText) + "\n  ")]) : _vm._e(), _vm._v(" "), !_vm.disableRipple ? _c('md-ink-ripple', {
    attrs: {
      "md-disabled": _vm.disabled
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-2bbecfcf_0", {
    source: "button:focus{outline:0}.md-button{min-width:var(--button-min-width);min-height:36px;margin:6px 8px;padding:0 16px;display:inline-block;position:relative;user-select:none;cursor:pointer;outline:0;background:0 0;border:0;transition:all .4s cubic-bezier(.25,.8,.25,1);color:currentColor;font-family:inherit;font-size:14px;font-style:inherit;font-variant:inherit;font-weight:600;letter-spacing:inherit;line-height:36px;text-align:center;text-transform:uppercase;text-decoration:none;vertical-align:top;white-space:nowrap;text-overflow:ellipsis;overflow:inherit}.md-button:not([disabled]):hover{background-color:rgba(255,255,255,.15)}@media (max-width:450px){.md-button:not([disabled]):hover{background-color:transparent}}.md-button:not([disabled]).md-raised:not(.md-icon-button){color:var(--theme-color,rgba(255,255,255,.9));background-color:#27292d}.md-button:not([disabled]).md-raised:not(.md-icon-button):hover{background-color:#383b40}.md-button:not([disabled]).md-raised.md-icon-button:not(.md-raised){color:var(--theme-color,rgba(255,255,255,.9))}.md-button:not([disabled]).md-fab{color:rgba(0,0,0,.87);background-color:var(--theme-color)}.md-button:not([disabled]).md-fab:hover{background-color:var(--theme-color)}.md-button:not([disabled]).md-fab.md-clean{color:var(--theme-color,rgba(255,255,255,.9));background-color:#27292d}.md-button:not([disabled]).md-fab.md-clean:hover{background-color:#383b40}.md-button:not([disabled]).same-on-hover.md-fab:hover,.md-button:not([disabled]).same-on-hover.md-raised:hover{background-color:#27292d}.md-button:not([disabled]).md-primary:not(.md-icon-button){color:var(--theme-color,#cddc39)}.md-button:not([disabled]).md-primary.md-fab,.md-button:not([disabled]).md-primary.md-raised{background-color:var(--theme-color,#cddc39);color:rgba(0,0,0,.87)}.md-button:not([disabled]).md-primary.md-fab:hover,.md-button:not([disabled]).md-primary.md-raised:hover{background-color:var(--theme-color,#cddc39)}.md-button:not([disabled]).md-primary.tdl-app-bar__sign-in{color:var(--theme-color,#cddc39)}.md-button:not([disabled]).md-primary.md-icon-button:not(.md-raised){color:var(--theme-color,#cddc39)}.md-button:not([disabled]).md-primary[md-theme=inverted]{background-color:#27292d;color:var(--theme-color,#cddc39)}.md-button:not([disabled]).md-primary[md-theme=inverted]:hover{background-color:#383b40}.md-button:not([disabled]).md-accent:not(.md-icon-button){color:var(--theme-color)}.md-button:not([disabled]).md-accent.md-raised{background-color:var(--theme-color);color:rgba(0,0,0,.87)}.md-button:not([disabled]).md-accent.md-raised:hover{background-color:var(--theme-color)}.md-button:not([disabled]).md-accent.md-icon-button:not(.md-raised){color:var(--theme-color)}.md-button:not([disabled]).md-warn:not(.md-icon-button){color:#cf6679}.md-button:not([disabled]).md-warn.md-fab,.md-button:not([disabled]).md-warn.md-raised{background-color:#cf6679;color:rgba(0,0,0,.87)}.md-button:not([disabled]).md-warn.md-fab:hover,.md-button:not([disabled]).md-warn.md-raised:hover{background-color:#bd5769}.md-button:not([disabled]).md-warn.md-icon-button:not(.md-raised){color:#cf6679}.md-button:not([disabled]).md-warn[md-theme=inverted]{background-color:#27292d;color:#cf6679}.md-button:not([disabled]).md-warn[md-theme=inverted]:hover{background-color:#383b40}.md-button:focus{outline:0}.md-button::-moz-focus-inner{border:0}.md-button:active:not([disabled]):hover{text-decoration:none}.md-button.dark-background{background-color:#27292d}.md-button.md-raised{border-radius:18px}.md-button.md-raised .md-ink-ripple{border-radius:18px!important}.md-button.md-raised:after{content:\"\";display:block;position:absolute;border-radius:18px}.md-button.md-raised.md-raised--thinner-border::after{top:2px;bottom:2px;left:2px;right:2px;border:1px solid currentColor}.md-button.md-raised.md-raised--thinner-border-gray::after{top:2px;bottom:2px;left:2px;right:2px;border:1px solid #5e626b}.md-button.md-raised.md-raised--thicker-border{overflow:visible}.md-button.md-raised.md-raised--thicker-border::after{top:-1px;bottom:-1px;left:-1px;right:-1px;border:3px solid #27292d}.md-button.md-raised.md-raised--thicker-border-gray{overflow:visible}.md-button.md-raised.md-raised--thicker-border-gray::after{top:-1px;bottom:-1px;left:-1px;right:-1px;border:3px solid #5e626b}.md-button.md-raised.md-raised--no-shadow{box-shadow:none;border-radius:2px}.md-button.md-raised.md-raised--no-shadow:after{display:none}.md-button.md-raised.md-raised--dark-shadow{box-shadow:1px 1px 6px rgba(1,1,1,.4)}.md-button.md-raised.md-raised--light-shadow{box-shadow:1px 1px 6px rgba(126,137,25,.4)}.md-button.md-raised.md-raised--gray-dark-shadow{box-shadow:2px 2px 6px #5e626b,-4px -4px 4px rgba(56,59,64,.7)}.md-button.md-dense{min-height:32px;line-height:32px;font-size:13px}.md-button.md-fab .md-icon{position:absolute;top:0;right:0;bottom:0;left:0}.md-button.md-icon-button{width:40px;min-width:40px;height:40px;margin:0 0;padding:8px;border-radius:50%;line-height:24px;box-shadow:none;border:none;overflow:inherit}.md-button.md-icon-button:not([disabled]):hover{background-color:rgba(255,255,255,.12)}.md-button.md-icon-button:after{display:none}.md-button.md-icon-button .md-icon{position:absolute;top:0;right:0;bottom:0;left:0;width:fit-content}.md-button.md-icon-button.md-dense{width:32px;min-width:32px;height:32px;min-height:32px;padding:5px}.md-button.md-icon-button .md-ink-ripple{border-radius:50%}.md-button.md-icon-button .md-ink-ripple .md-ripple{top:0!important;right:0!important;bottom:0!important;left:0!important}.md-button.md-icon-button .md-ripple.md-active{animation-duration:.9s}.md-button.md-fab{width:56px;height:56px;padding:0;min-width:0;overflow:hidden;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:56px;line-height:56px;background-clip:padding-box;transition:all .4s cubic-bezier(.25,.8,.25,1);transition-property:background-color,box-shadow,transform}.md-button.md-fab:focus,.md-button.md-fab:hover{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px rgba(0,0,0,.14),0 1px 14px rgba(0,0,0,.12)}.md-button.md-fab.md-mini{width:40px;height:40px;line-height:20px}.md-button.md-fab .md-ink-ripple{border-radius:56px}.md-button[disabled]{color:rgba(255,255,255,.38);cursor:default;pointer-events:none}.md-button[disabled].md-fab,.md-button[disabled].md-raised{background-color:rgba(255,255,255,.12)}.md-button[disabled].md-fab{box-shadow:none}.md-button.md-fake-disabled{color:rgba(255,255,255,.38)!important;cursor:default!important}.md-button.md-fake-disabled.md-fab,.md-button.md-fake-disabled.md-raised{background-color:rgba(255,255,255,.12)!important}.md-button.md-fake-disabled.md-fab{box-shadow:none!important}.md-button:after{transition:all .4s cubic-bezier(.25,.8,.25,1)}.md-button .md-ink-ripple{border-radius:2px;background-clip:padding-box;overflow:hidden}.md-button__badge{background-color:#ef5350;color:rgba(255,255,255,.9);position:absolute;top:1px;right:-1px;min-width:18px;height:18px;padding:0 4.5px;border-radius:36px;font-size:12px;line-height:18px;z-index:1}.md-button:not(.md-icon-button) :not(.md-fab) .md-icon{margin-right:0!important}.md-button.md-delete-button{color:#cf6679!important}.md-button.md-fab .md-icon,.md-button.md-icon-button .md-icon{display:block}.md-fab.md-fab-bottom-center,.md-fab.md-fab-bottom-left,.md-fab.md-fab-bottom-right,.md-fab.md-fab-top-center,.md-fab.md-fab-top-left,.md-fab.md-fab-top-right,.md-speed-dial.md-fab-bottom-center,.md-speed-dial.md-fab-bottom-left,.md-speed-dial.md-fab-bottom-right,.md-speed-dial.md-fab-top-center,.md-speed-dial.md-fab-top-left,.md-speed-dial.md-fab-top-right{margin:0;position:absolute;z-index:10}.md-fab.md-fab-top-left,.md-speed-dial.md-fab-top-left{top:24px;left:24px}.md-fab.md-fab-top-center,.md-speed-dial.md-fab-top-center{top:24px;left:50%;transform:translateX(-50%)}.md-fab.md-fab-top-right,.md-speed-dial.md-fab-top-right{top:24px;right:24px}.md-fab.md-fab-bottom-left,.md-speed-dial.md-fab-bottom-left{bottom:24px;left:24px}.md-fab.md-fab-bottom-center,.md-speed-dial.md-fab-bottom-center{bottom:24px;left:50%;transform:translateX(-50%)}.md-fab.md-fab-bottom-right,.md-speed-dial.md-fab-bottom-right{right:24px;bottom:24px}.md-button-tooltip.md-tooltip-top{margin-top:-8px}.md-button-tooltip.md-tooltip-right{margin-left:8px}.md-button-tooltip.md-tooltip-bottom{margin-top:8px}.md-button-tooltip.md-tooltip-left{margin-left:-8px}@media (max-width:450px){button.md-wide{white-space:normal;padding-top:4px;padding-bottom:4px;line-height:20px}}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
